import React from "react";
import {connect} from "react-redux";
import {toggleFirstPartSidebarAction} from "../../../state/application/actions";
import {productCategoryNameMappingByConfigurations} from "../../../helpers/productHelper";
import {ConfigurationsType} from "../../../types/configurations";
import translations from "../../../translations";
import {AppParametersType} from "../../../types/app";
import {hasActiveFlow} from "../../../helpers/configurationHelper";
import SatelliteImageryForm from "./SatelliteImagery/SatelliteImageryFormContainer";
import InvalidationForm from "./Invalidation/InvalidationFormContainer";
import ReprocessingForm from "./Reprocessing/ReprocessingFormContainer";

interface PropsType {
    configurations: ConfigurationsType;
    isInterferometricStackSearch: boolean;
    allProducts: any;
    sidebarFirstPartShown: boolean;
    categoryParameterOnUrl: boolean;
    tabActiveInLeftSidebar: number;
    toggleFirstPartSidebarActionHandler: any;
    appParameters: AppParametersType;
    language: string;
}

const SearchFormSidebar = (props: PropsType) => {
  const {
    configurations,
    isInterferometricStackSearch,
    allProducts,
    sidebarFirstPartShown,
    tabActiveInLeftSidebar,
    toggleFirstPartSidebarActionHandler,
    language,
    appParameters,
  } = props;

  const forms = [
    {
      icon: "#satelliteimagery-icon",
      name: translations("satelliteImageryLeftSearchBar", language),
      component: SatelliteImageryForm,
    },
    {
      icon: "#syncronise-icon",
      name: translations("invalidateLeftSearchBar", language),
      component: InvalidationForm,
    },
    {
      icon: "#checkmark-icon",
      name: translations("massiveReprocessingLeftSearchBar", language),
      component: ReprocessingForm,
    },
  ];

  let tabName = "";
  let currentForm;
  if (tabActiveInLeftSidebar !== null) {
    // currentform
    currentForm = forms[tabActiveInLeftSidebar];
    // tabname
    const activeFlow = hasActiveFlow(appParameters);
    if (activeFlow !== false) { // flusso applicativo (diverso da quello standard basato sui prodotti)
      tabName = activeFlow.name;
    } else {
      const {productName} = productCategoryNameMappingByConfigurations(
        configurations,
        allProducts
      );
      tabName =
                configurations.description || `${currentForm.name} - ${productName.name}`;
    }
  }

  const hasActiveFlowBool = hasActiveFlow(appParameters);
  const showCloseButton = hasActiveFlowBool === false;

  return (tabActiveInLeftSidebar !== null ? (
    <div
      className={`first-part ${
        sidebarFirstPartShown ? "d-flex" : "d-none"
      } h-100 ml-0`}
    >
      <div className="form-big-wrapper pl-0">
        <div className="sidebar-header d-flex justify-content-between align-items-center px-3 py-4">
          <h6 className="title-like text-uppercase m-0" title={tabName}>
            {tabName}
          </h6>
          {showCloseButton && (
            <button
              className="sidebar-close-btn remove-btn-defaults"
              type="button"
              onClick={() => toggleFirstPartSidebarActionHandler(!sidebarFirstPartShown)}
            >
              <svg>
                <use xlinkHref="#left_arrow-icon" fill="#9A9BA6" />
              </svg>
              <span>{translations("closeLeftSearchBar", language)}</span>
            </button>
          )}
        </div>
        <currentForm.component
          configurations={configurations}
          isInterferometricStackSearch={isInterferometricStackSearch}
        />
      </div>
    </div>
  ) : <></>
  // TODO: mostrare errore
  );
};

const mapStateToProps = (state) => ({
  sidebarFirstPartShown: state.application.sidebarFirstPartShown,
  appParameters: state.application.appParameters,
  tabActiveInLeftSidebar: state.application.tabActiveInLeftSidebar,
  categoryParameterOnUrl: state.application.categoryParameterOnUrl,
  configurations: state.application.configurations,
  allProducts: state.product.allProducts,
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  language: state.application.appParameters.language,
});

const mapDispatchToProps = (dispatch) => ({
  toggleFirstPartSidebarActionHandler: (e) => dispatch(toggleFirstPartSidebarAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchFormSidebar);
